<script>
import WishlistButton from '@phoenix/mixins/components/wishlist/WishlistButton';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: { PhxsgButton },

  mixins: [WishlistButton],

  props: {
    defaultInWishlistIcon: {
      type: String,
      default: 'bookmark-active',
    },
    type: {
      type: String,
      default: 'icon',
      validator: (value) => ['icon', 'text'].includes(value),
    },
  },

  data() {
    return {
      defaultIcon: 'bookmark',
    };
  },

  computed: {
    isIcon() {
      return this.type === 'icon';
    },

    isText() {
      return this.type === 'text';
    },

    label() {
      return this.isInWishlist(this.reference)
        ? this.$t('Wishlist.removeFromWishlist')
        : this.$t('Wishlist.addToWishlist');
    },
  },
};
</script>

<template>
  <PhxsgButton
    :variant="isText ? 'fade' : null"
    :no-caps="isText"
    :icon-only="isIcon"
    :icon-id="isIcon ? icon : undefined"
    :label="label"
    :data-cy="dataCy"
    @click.prevent="toggleWishlistProduct"
  />
</template>
